import ApiService from "@/api";
import TaskRemoveRequest from "@/api/Main/dataSource/api/projects/task/i-service/models/task/request/TaskRemoveRequest";
import { ResponseModel } from "@/models";
import { TirPmNotificationEventBus, TirPmNotificationModel } from "tir-components";

/**Сервис для вызова запросов */
export class AdapterService {
  /**Сервис api */
  api = new ApiService();

  /**Удаление задачи */
  RemoveTask(taskId: number, taskName: string) {
    return new Promise<ResponseModel<boolean>>((resolve) => {
      const result = new ResponseModel<boolean>();
      this.api.Main.ProjectTaskSaveService.removeAsync(
        new TaskRemoveRequest({
          TaskId: taskId,
        }),
      )
        .then((response) => {
          result.Value = !!response;
          this.sendNotification(`Успешное удаление задачи "${taskName}"`, "success");
          return resolve(result);
        })
        .catch((error: any) => {
          console.error("ProjectTaskSaveService.Remove");
          this.sendNotification(error?.ErrorMessage);
          result.IsSuccess = false;
          return resolve(result);
        });
    });
  }

  /**Отправка уведомления об ошибке */
  sendNotification(message: string, type: "error" | "info" | "success" | "warn" = "error") {
    TirPmNotificationEventBus.emit(
      "add",
      new TirPmNotificationModel({
        title: message,
        type: type,
        group: "general",
        life: 5000,
        closable: true,
        callbackButton: () => {},
      }),
    );
  }
}
